/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import iconCloseGray from '../../assets/images/svg/icon-close-gray.svg';
import iconCloseBlue from '../../assets/images/svg/icon-close-blue.svg';
import iconReturnBlue from '../../assets/images/svg/icon-return-blue.svg';
import './modal.scss';

type Props = {
  children: any;
  onClose: any;
  hasClose: boolean;
  hasReturn?: boolean;
  isOpen?: boolean;
  className?: string;
  classNameBody?: string;
};

const Modal: React.FC<Props> = (props: Props) => {
  const {
    children,
    onClose,
    hasClose,
    hasReturn,
    isOpen,
    className,
    classNameBody,
  } = props;

  return isOpen ? (
    <div className={`modal-overlay ${className ?? ''}`}>
      <div className={`modal-body ${classNameBody ?? ''}`}>
        <div style={{ width: '100%' }}>
          {hasClose ? (
            <div className="modal-close">
              <span className="icon-close" onClick={onClose}>
                <img src={iconCloseGray} alt="icon-close" />
              </span>
            </div>
          ) : (
            <div className="modal-close-blue">
              <span className="icon-close" onClick={onClose}>
                {hasReturn ? (
                  <img src={iconReturnBlue} alt="icon-return-blue" />
                ) : (
                  <img src={iconCloseBlue} alt="icon-close-blue" />
                )}
              </span>
            </div>
          )}
          {children}
        </div>
      </div>
    </div>
  ) : null;
};

Modal.defaultProps = {
  className: '',
  hasReturn: false,
};

export default Modal;
